import { BehaviorSubject } from "rxjs";
import { HandleResponse } from "../Healper/handleResponse";

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);
const currentTokenSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("token"))
);
//const urlAddress = "http://localhost:5000/api/";
const urlAddress = "https://covidapi.ihpath.com/api/";
export const apiFunctions = {
  getData,
  getDataWithParameter,
  saveData,
  updateData,
  deleteData,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  currentToken: currentTokenSubject.asObservable(),
  get currentTokenValue() {
    return currentTokenSubject.value;
  },
};

function getData(controller) {
  const requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
    },
  };
  const address = urlAddress + controller;
  return fetch(address, requestOptions)
    .then(HandleResponse)
    .then((result) => {
      return result;
    })
    .catch((e) => {
      return e;
    });
}
function getDataWithParameter(controller, data) {
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
    },
    body: JSON.stringify(data),
  };
  return fetch(urlAddress + controller, requestOptions)
    .then(HandleResponse)
    .then((result) => {
      return result;
    })
    .catch((e) => {
      return e;
    });
}
function saveData(controller, data) {
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
    },
    body: JSON.stringify(data),
  };

  return fetch(urlAddress + controller, requestOptions)
    .then(HandleResponse)
    .then((result) => {
      return result;
    });
}

function updateData(controller, newData, oldData) {
  let data = { newData: newData, oldData: oldData };
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
    },
    body: JSON.stringify({
      data: data,
      userName: JSON.parse(localStorage.getItem("currentUser")),
    }),
  };

  return fetch(urlAddress + controller, requestOptions)
    .then(HandleResponse)
    .then((result) => {
      return result;
    });
}

function deleteData(controller, data) {
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("token")),
    },
    body: JSON.stringify(data),
  };

  return fetch(urlAddress + controller, requestOptions)
    .then(HandleResponse)
    .then((result) => {
      return result;
    });
}

export default apiFunctions;
